export function embedPaymentCss() {
  return {
    input: {
      background: '#fff',
      border: '1px solid',
      'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
      'box-sizing': 'border-box',
      'font-family': 'serif',
      'font-size': '16px',
      'line-height': '1',
      margin: '0 .5em 0 0',
      'max-width': '100%',
      outline: '0',
      padding: '0.5278em',
      'vertical-align': 'baseline',
      height: '50px',
      width: '100% !important',
    },
    '#secure-payment-field': {
      'font-family': 'sans-serif',
      'box-sizing': 'border-box',
      display: 'block',
      height: '45px',
      padding: '6px 12px',
      'font-size': '14px',
      'line-height': '1.42857143',
      color: '#495057',
      'background-color': '#fff',
      border: '1px solid #ced4da',
      'border-radius': '.25rem',
      '-webkit-box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
      'box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
      '-webkit-transition':
        'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
      '-o-transition':
        'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
      transition: 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
      width: '100%',
    },
    'button#secure-payment-field': {
      color: '#fff',
      'background-color': '#007bff',
      'border-color': '#007bff',
      'min-width': '38px',
      height: '38px',
      'text-align': 'center',
      border: '2px solid',
      font: '700 14px "Inter", sans-serif',
      padding: '0 24px',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      'border-radius': '9999px !important',
      cursor: 'pointer',
    },
    'button#secure-payment-field:hover': {
      color: '#FFFFFF',
      'background-color': '#0475F5',
      'border-color': '#0475F5',
    },
    '#secure-payment-field[name=submit]:focus': {
      color: '#ffffff',
      'background-color': '#258851',
      outline: 'none',
    },
    '#secure-payment-field[name=submit]:hover': {
      'background-color': '#258851',
    },
    '#secure-payment-field-wrapper #secure-payment-field:focus': {
      border: '1px solid #1362e2',
      outline: 'none',
      'box-shadow': 'none',
      height: '40px',
    },
    'secure-payment-field-wrapper #secure-payment-field': {
      height: '50px',
    },
    'input[type=submit]': {
      'box-sizing': 'border-box',
      display: 'inline-block',
      padding: '6px 12px',
      'margin-bottom': '0',
      'font-size': '14px',
      'font-weight': '400',
      'line-height': '1.42857143',
      'text-align': 'center',
      'white-space': 'nowrap',
      'vertical-align': 'middle',
      '-ms-touch-action': 'manipulation',
      'touch-action': 'manipulation',
      cursor: 'pointer',
      '-webkit-user-select': 'none',
      '-moz-user-select': 'none',
      '-ms-user-select': 'none',
      'user-select': 'none',
      'background-image': 'none',
      border: '1px solid transparent',
      'border-radius': '4px',
      color: '#fff',
      'background-color': '#337ab7',
      'border-color': '#2e6da4',
    },
    '#secure-payment-field[placeholder]': {
      'letter-spacing': '3px',
    },
    '#secure-payment-field[name=cardCvv]': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
      'background-size': '63px 40px',
    },
    'input#secure-payment-field[name=cardNumber]': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
      'background-size': '55px 35px',
    },
    '#secure-payment-field.card-number.invalid.card-type-visa': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
      'background-size': '83px 88px',
      'background-position-y': '-44px',
    },
    '#secure-payment-field.card-number.valid.card-type-visa': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
      'background-size': '82px 86px',
    },
    '#secure-payment-field.card-number.invalid.card-type-discover': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
      'background-size': '85px 90px',
      'background-position-y': '-44px',
    },
    '#secure-payment-field.card-number.valid.card-type-discover': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
      'background-size': '85px 90px',
      'background-position-y': '1px',
    },
    '#secure-payment-field.card-number.invalid.card-type-amex': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
      'background-size': '50px 90px',
      'background-position-y': '-44px',
    },
    '#secure-payment-field.card-number.valid.card-type-amex': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
      'background-size': '50px 90px',
    },
    '#secure-payment-field.card-number.invalid.card-type-mastercard': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
      'background-size': '62px 105px',
      'background-position-y': '-52px',
    },
    '#secure-payment-field.card-number.valid.card-type-mastercard': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
      'background-size': '62px 105px',
      'background-position-y': '-1px',
    },
    '#secure-payment-field.card-number.invalid.card-type-jcb': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
      'background-size': '55px 94px',
      'background-position-y': '-44px',
    },
    '#secure-payment-field.card-number.valid.card-type-jcb': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
      'background-size': '55px 94px',
      'background-position-y': '2px',
    },
    'input#secure-payment-field[name=cardNumber]::-ms-clear': {
      display: 'none',
    },
  };
}

export function paymentCss() {
  return {
    input: {
      background: '#fff',
      border: '1px solid',
      'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
      'box-sizing': 'border-box',
      'font-family': 'serif',
      'font-size': '16px',
      'line-height': '1',
      margin: '0 .5em 0 0',
      'max-width': '100%',
      outline: '0',
      padding: '0.5278em',
      'vertical-align': 'baseline',
      height: '50px',
      width: '100% !important',
    },
    '#secure-payment-field': {
      'font-family': '"Inter", sans-serif',
      'box-sizing': 'border-box',
      display: 'block',
      height: '40px',
      padding: '0.4375rem 1rem',
      'font-size': '1rem',
      'line-height': '1.5rem',
      color: '#203645',
      'background-color': '#fff',
      border: '1px solid #abc6d8',
      'border-radius': '0.5rem',
      '-webkit-transition':
        'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
      '-o-transition':
        'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
      transition: 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
      width: '100%',
    },
    '#secure-payment-field::placeholder': {
      color: '#b0b4b5',
    },
    'button#secure-payment-field': {
      color: '#FFFFFF',
      'background-color': '#1362E2',
      // 'border-color': '#1362E2',
      // 'min-width': '38px',
      height: '56px',
      'text-align': 'center',
      border: 'none',
      font: '700 16px "Inter", sans-serif',
      padding: '0.875rem 2em',
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      'border-radius': '9999px !important',
      cursor: 'pointer',
    },
    'button#secure-payment-field:hover': {
      'background-color': '#0470ec',
    },
    'button#secure-payment-field:focus': {
      'background-color': '#0097ff',
    },
    '#secure-payment-field[name=submit]:focus': {
      color: '#ffffff',
      'background-color': '#258851',
      outline: 'none',
    },
    '#secure-payment-field[name=submit]:hover': {
      'background-color': '#258851',
    },
    '#secure-payment-field-wrapper #secure-payment-field:not(.submit):focus': {
      border: '1px solid #0097ff',
      outline: 'none',
      'box-shadow': 'none',
    },
    'secure-payment-field-wrapper #secure-payment-field': {
      height: '50px',
    },
    'input[type=submit]': {
      'box-sizing': 'border-box',
      display: 'inline-block',
      padding: '6px 12px',
      'margin-bottom': '0',
      'font-size': '14px',
      'font-weight': '400',
      'line-height': '1.42857143',
      'text-align': 'center',
      'white-space': 'nowrap',
      'vertical-align': 'middle',
      '-ms-touch-action': 'manipulation',
      'touch-action': 'manipulation',
      cursor: 'pointer',
      '-webkit-user-select': 'none',
      '-moz-user-select': 'none',
      '-ms-user-select': 'none',
      'user-select': 'none',
      'background-image': 'none',
      border: '1px solid transparent',
      'border-radius': '4px',
      color: '#fff',
      'background-color': '#337ab7',
      'border-color': '#2e6da4',
    },
    '#secure-payment-field[placeholder]': {
      'letter-spacing': '1px',
    },
    '#secure-payment-field[name=cardCvv]': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
      'background-size': '63px 40px',
    },
    'input#secure-payment-field[name=cardNumber]': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
      'background-size': '40px',
      'background-position': '98% 50%',
    },
    '#secure-payment-field.card-number.invalid.card-type-visa': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
      'background-size': '83px 88px',
      'background-position-y': '-44px',
    },
    '#secure-payment-field.card-number.valid.card-type-visa': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
      'background-size': '80px',
    },
    '#secure-payment-field.card-number.invalid.card-type-discover': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
      'background-size': '85px 90px',
      'background-position-y': '-44px',
    },
    '#secure-payment-field.card-number.valid.card-type-discover': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
      'background-size': '80px',
      'background-position-y': '-1px',
    },
    '#secure-payment-field.card-number.invalid.card-type-amex': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
      'background-size': '50px 90px',
      'background-position-y': '-44px',
    },
    '#secure-payment-field.card-number.valid.card-type-amex': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
      'background-size': '40px',
      'background-position-x': '99%',
    },
    '#secure-payment-field.card-number.invalid.card-type-mastercard': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
      'background-size': '62px 105px',
      'background-position-y': '-52px',
    },
    '#secure-payment-field.card-number.valid.card-type-mastercard': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
      'background-size': '50px',
      'background-position-y': '-1px',
      'background-position-x': '99%',
    },
    '#secure-payment-field.card-number.invalid.card-type-jcb': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
      'background-size': '55px 94px',
      'background-position-y': '-44px',
    },
    '#secure-payment-field.card-number.valid.card-type-jcb': {
      background:
        'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
      'background-size': '50px',
      'background-position-y': '-1px',
      'background-position-x': '99%',
    },
    'input#secure-payment-field[name=cardNumber]::-ms-clear': {
      display: 'none',
    },
  };
}
